import { trpc, TRPCReactQueryOptions, TRPCRouterInputs, TRPCRouterOutputs } from '@sternum/web/services/trpc';

const emptyData: TRPCRouterOutputs['systemClient']['getClients'] = [];

export function useClients(
  request: TRPCRouterInputs['systemClient']['getClients'],
  options?: TRPCReactQueryOptions['systemClient']['getClients'],
) {
  const { data, ...rest } = trpc.systemClient.getClients.useQuery(request, {
    ...options,
  });

  return {
    clients: data || emptyData,
    ...rest,
  };
}
